import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./style/profile.css";
import Sidebar from "./sidebar/Sidebar";
import Dashboard from "./DashBoard/Dashboard";
import AccountDetails from "./accountDeails/AccountDetails";
import UserAddress from "./UserAddress/UserAddress";
import UserDashboard from "./UserDashboard/UserDashboard";
import { useLocation, useNavigate } from "react-router-dom";
import UserAuth from "../PrivateRoutes/UserAuth";
import { TokenVerify } from "../../redux/actions/User";
import toast from "react-hot-toast";
import MarketplaceNewUIFooter from "../Home/MarketplaceNewUI/MarketplaceNewUIFooter";
import { useProfilePage } from "./ProfileSidebarContext";

const SECTION_TITLES = {
  0: "Dashboard",
  2: "Account Details",
  3: "Addresses",
  4: "Organizer Dashboard",
};

export default function Index() {
  const user = useSelector((state) => state.user.user);
  const { active, setActive } = useProfilePage();
  const dispatch = useDispatch();
  const token = localStorage.getItem("instapass_user_token");
  const location = useLocation();
  const navigate = useNavigate();
  const newPage = location.state?.data;

  const sectionTitle = useMemo(() => SECTION_TITLES[active] || "My Profile", [active]);

  useEffect(() => {
    if (newPage === 1) {
      navigate("/my-tickets", { replace: true });
    }
  }, [newPage, navigate]);

  useEffect(() => {
    if (token) {
      const getResult = async () => {
        const result = await dispatch(TokenVerify());
        if (result === "jwt expired") {
          navigate("/");
          toast.error("Session Expire, Please Login");
        }
      };
      if (!user?.email) {
        getResult();
      }
    }
  }, [dispatch, navigate, token, user?.email]);

  return (
    <UserAuth>
      <div
        className="min-h-screen bg-[#0a0e1a] flex flex-col profile-page overflow-x-hidden lg:overflow-x-visible"
        style={{ fontFamily: "'Outfit', 'Inter', sans-serif" }}
      >
        <div className="flex flex-1 w-full">
          <Sidebar active={active} setactive={setActive} />

          <main className="flex-1 min-w-0 p-4 sm:p-6 lg:p-10">
            <div className="lg:hidden mb-4">
              <h1 className="text-[15px] text-white truncate" style={{ fontWeight: 700 }}>
                {sectionTitle}
              </h1>
            </div>

            <div className="profile-content-panel">
              {active === 0 && (
                <div className="min-h-[50vh] flex justify-center items-center">
                  <Dashboard />
                </div>
              )}
              {active === 2 && <AccountDetails />}
              {active === 3 && <UserAddress />}
              {active === 4 &&
                (user?.userType === "organizer" || user?.role === "admin") && (
                <UserDashboard setActive={setActive} />
              )}
            </div>
          </main>
        </div>

        <MarketplaceNewUIFooter />
      </div>
    </UserAuth>
  );
}
